import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[evkMatDisplay3]'
})
export class MatDisplay3Directive {

    @HostBinding('class')
    public class = 'mat-display-3';

    @HostBinding('style.margin')
    public margin = 0;

}
